import React from 'react'
import styled from 'styled-components'

export type TeaserProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
  Pick<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'href' | 'target'> & {
    image?: {
      url: string
      width: number
      height: number
    }
    title?: string
    cta?: string
  }

const preventDefault = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  e.preventDefault
}

const TeaserTitle = styled.div<{ src?: string }>`
  font-size: 0;
  padding-bottom: 56.25%;
  background: center/cover no-repeat #f2f2f2 url('${(props) => props.src}');
`

const Teaser: React.FC<TeaserProps> = ({ image, title, children, cta, href, target, className, ...props }) => {
  return (
    <div {...props} className={'teaser' + (className ? ' ' + className : '')}>
      <a onClick={props.onClick ? preventDefault : undefined} href={href} target={target ?? '#'}>
        {!!image && <TeaserTitle src={image.url} />}
        {!!(title || children) && (
          <div className="teaser__content">
            {!!title && <h3>{title}</h3>}
            {children}
            {!!cta && <button className="button">{cta}</button>}
          </div>
        )}
      </a>
    </div>
  )
}

export default Teaser
